import { useTracking } from 'react-tracking';

import FeedCard from '@/components/FeedCard';

import type { MarketFeedCompanyEvents } from '../../hooks/useMarketFeed';

import { FeedCardContainer } from './styled';

export interface FeedItemProps {
  company: MarketFeedCompanyEvents;
}

const MarketFeedCard = ({ company }: FeedItemProps) => {
  const { Track } = useTracking({
    type: 'track',
    subject: 'SidePanel',
  });
  return (
    <Track>
      <FeedCardContainer>
        {company.feedItems.map((feedItem, i) => {
          return (
            <FeedCard
              key={`feed-card-${feedItem.id}`}
              index={i}
              company={company}
              data-cy-id="market-feed-card"
            />
          );
        })}
      </FeedCardContainer>
    </Track>
  );
};

export default MarketFeedCard;
